import {
    PropsWithChildren, useRef,
} from 'react';
import html2canvas from 'html2canvas';
import {ScreenshotContext, ScreenshotContextType} from '../../hooks/useScreenshot';
import {HIDDEN_FROM_SCREENSHOT_CLASS, HIDE_FROM_SCREENSHOT_CLASS} from '../../configs/vars';

const ScreenshotProvider = ({children}: PropsWithChildren) => {
    const screenshotRef = useRef<HTMLDivElement>(null);

    const hideBlockers = () => {
        const elementsToHide = document.querySelectorAll(`.${HIDE_FROM_SCREENSHOT_CLASS}`);

        elementsToHide.forEach(element => {
            element.classList.add(HIDDEN_FROM_SCREENSHOT_CLASS);
        });
    };

    const showBlockers = () => {
        const elementsToShow = document.querySelectorAll(`.${HIDE_FROM_SCREENSHOT_CLASS}`);

        elementsToShow.forEach(element => {
            element.classList.remove(HIDDEN_FROM_SCREENSHOT_CLASS);
        });
    };

    const captureScreenshot = async (): Promise<string | null> => {
        if (screenshotRef.current) {
            hideBlockers();

            const canvas = await html2canvas(screenshotRef.current);
            const imageData = canvas.toDataURL('image/png');

            showBlockers();

            return imageData;
        }

        return null;
    };

    const contextValue: ScreenshotContextType = {
        captureScreenshot,
    };

    return (
        <ScreenshotContext.Provider value={contextValue}>
            <div ref={screenshotRef}>
                {children}
            </div>
        </ScreenshotContext.Provider>
    );
};

export default ScreenshotProvider;
